import { render } from "./PersonalAccountForm.vue?vue&type=template&id=4ac59b94&scoped=true"
import script from "./PersonalAccountForm.vue?vue&type=script&lang=js"
export * from "./PersonalAccountForm.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4ac59b94"

export default script